function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css",
  id: "style10"
}, ".jhu_svg__st0{fill:#062f6b}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "jhu_svg__g82",
  transform: "translate(-21 -264)",
  fill: "#000",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M80.9 307.9c0-2-.1-5.8-.6-6.8-.2-.4-.8-.6-1.6-.7l-.8-.1c-.2-.2-.1-.7.1-.8 1.2.1 2.5.1 3.7.1 1.4 0 2.3 0 3.4-.1.3.2.2.6.1.8l-.8.1c-.8.1-1.4.4-1.6.8-.5 1.1-.5 4.8-.5 6.7v3.7c0 2.8-.5 5.8-2.3 7.8-1.4 1.5-3.8 2.4-6.2 2.4-2.3 0-4.5-.4-6.1-1.8-1.7-1.4-2.5-3.8-2.5-7.7v-7.7c0-3.4-.1-4-2-4.1l-.8-.1c-.2-.1-.1-.7.1-.8 1.6.1 2.7.1 4 .1 1.3 0 2.4 0 4-.1.2.1.3.7.1.8l-.8.1c-1.9.2-2 .7-2 4.1v7.1c0 5.3 1.6 8.7 6.6 8.7 4.7 0 6.5-3.7 6.5-8.7z",
  id: "jhu_svg__path12",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M123.6 315.7c0 1 0 4.9.1 5.7-.1.2-.3.4-.6.4-.4-.6-1.3-1.7-4.2-4.9l-7.6-8.6c-.9-1-3.1-3.7-3.8-4.4h-.1c-.1.4-.2 1.1-.2 2.1v7.1c0 1.5 0 5.8.6 6.8.2.4.8.6 1.7.6l1 .1c.2.3.2.6-.1.8-1.5-.1-2.6-.1-3.8-.1-1.4 0-2.3 0-3.4.1-.2-.2-.3-.6-.1-.8l.9-.1c.8-.1 1.3-.3 1.4-.7.5-1.2.4-5.2.4-6.7v-9.4c0-.9 0-1.6-.7-2.4-.5-.5-1.2-.7-2-.8l-.5-.1c-.2-.2-.2-.7.1-.8 1.4.1 3.1.1 3.7.1.5 0 1.1 0 1.5-.1.7 1.7 4.5 6 5.6 7.2l3.2 3.6c2.3 2.5 3.9 4.3 5.4 5.9h.1c.1-.2.1-.7.1-1.4v-7c0-1.5 0-5.8-.7-6.8-.2-.3-.7-.5-2-.7l-.6-.1c-.2-.2-.2-.7.1-.8 1.5.1 2.6.1 3.9.1 1.4 0 2.3 0 3.4-.1.3.2.3.6.1.8l-.5.1c-1 .2-1.7.4-1.8.7-.6 1.2-.5 5.2-.5 6.7v7.9z",
  id: "jhu_svg__path14",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M147.9 304.6c0-3.5-.1-4-2-4.2l-.8-.1c-.2-.1-.1-.7.1-.8 1.6.1 2.7.1 4.1.1 1.3 0 2.4 0 4-.1.2.1.3.7.1.8l-.8.1c-1.9.2-2 .7-2 4.2v11.6c0 3.5.1 3.9 2 4.1l.8.1c.2.1.1.7-.1.8-1.6-.1-2.7-.1-4-.1-1.4 0-2.5 0-4.1.1-.2-.1-.3-.6-.1-.8l.8-.1c1.9-.2 2-.7 2-4.1z",
  id: "jhu_svg__path16",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M174.4 303.1c-.7-1.8-1.2-2.5-2.6-2.7l-.6-.1c-.2-.2-.2-.7.1-.8 1 .1 2 .1 3.4.1s2.6 0 4-.1c.2.1.3.6.1.8l-.5.1c-1.2.2-1.5.4-1.5.6.1.3.6 2.1 1.6 4.6 1.5 3.8 3 7.5 4.6 11.3 1-2.2 2.4-5.5 3.1-7.3.9-2.2 2.5-5.9 3-7.3.3-.7.3-1 .3-1.3 0-.2-.3-.5-1.5-.6l-.6-.1c-.2-.2-.2-.7.1-.8.9.1 2.2.1 3.4.1 1.1 0 2.1 0 3.2-.1.2.1.2.7.1.8l-1 .1c-.8.1-1.3.5-1.7 1.1-.9 1.5-2.2 4.2-3.7 7.5l-1.8 4c-1.3 3-2.8 6.8-3.4 8.5-.1.1-.2.1-.3.1-.2 0-.3 0-.5-.1-.4-1.4-.9-3-1.5-4.3z",
  id: "jhu_svg__path18",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M213.7 304.6c0-3.4-.1-3.9-2-4.1l-.5-.1c-.2-.1-.1-.7.1-.8 1.4.1 2.5.1 3.8.1h6.1c2.1 0 4 0 4.4-.1.2.6.4 2.9.5 4.4-.1.2-.7.3-.8.1-.5-1.5-.8-2.7-2.5-3.1-.7-.2-1.7-.2-3.2-.2h-2.4c-1 0-1 .1-1 1.3v6.5c0 .9.1.9 1.1.9h1.9c1.4 0 2.4-.1 2.8-.2.4-.1.6-.3.8-1.1l.3-1.3c.2-.2.7-.2.8 0 0 .8-.1 2.1-.1 3.3 0 1.2.1 2.4.1 3.1-.1.2-.7.2-.8 0l-.3-1.3c-.1-.6-.4-1.1-1-1.2-.5-.1-1.2-.2-2.5-.2h-1.9c-1 0-1.1 0-1.1.9v4.6c0 1.7.1 2.8.6 3.4.4.4 1.1.7 4 .7 2.5 0 3.5-.1 4.2-.5.6-.3 1.5-1.5 2.3-3.2.2-.2.7-.1.8.2-.2 1.1-1 3.7-1.5 4.5-2.9-.1-5.8-.1-8.8-.1H215c-1.4 0-2.5 0-4.4.1-.2-.1-.3-.6-.1-.8l1.1-.1c1.9-.2 2-.7 2-4.1v-11.6z",
  id: "jhu_svg__path20",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M249.1 304.6c0-3.1-.1-3.7-1.4-3.8l-1-.1c-.2-.2-.2-.7 0-.8 1.8-.2 4.1-.3 7.3-.3 2 0 4 .2 5.5 1 1.6.8 2.7 2.3 2.7 4.6 0 3.1-2.4 4.8-4.1 5.5-.2.2 0 .5.2.8 2.6 4.2 4.3 6.8 6.6 8.7.6.5 1.4.9 2.3.9.2.1.2.3 0 .5-.3.1-.8.2-1.4.2-2.8 0-4.5-.8-6.8-4.1-.9-1.2-2.2-3.5-3.2-4.9-.5-.7-1-1-2.3-1-1.5 0-1.5 0-1.5.7v4.1c0 3.4.1 3.8 2 4.1l.7.1c.2.2.1.7-.1.8-1.5-.1-2.6-.1-3.9-.1-1.4 0-2.6 0-4.1.1-.2-.1-.3-.6-.1-.8l.8-.1c1.9-.2 2-.7 2-4.1v-12zm2.7 4.7c0 .6 0 .9.1 1.1.1.1.6.2 2.2.2 1.2 0 2.4-.1 3.4-.9.9-.7 1.6-1.8 1.6-4 0-2.6-1.6-5-5.2-5-2 0-2.1.1-2.1 1z",
  id: "jhu_svg__path22",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M288.6 321.8c-2.7 0-4.5-.9-5.1-1.2-.4-.7-.8-3-.9-4.6.2-.2.7-.3.8-.1.5 1.7 1.8 4.9 5.6 4.9 2.7 0 4.1-1.8 4.1-3.8 0-1.4-.3-3-2.7-4.6l-3.1-2c-1.6-1.1-3.5-2.9-3.5-5.6 0-3.1 2.4-5.6 6.7-5.6 1 0 2.2.2 3 .4.4.1.9.2 1.1.2.3.8.6 2.6.6 4-.1.2-.7.3-.8.1-.4-1.6-1.3-3.7-4.4-3.7-3.2 0-3.9 2.1-3.9 3.6 0 1.9 1.6 3.3 2.8 4l2.6 1.6c2.1 1.3 4.1 3.2 4.1 6.3 0 3.6-2.7 6.1-7 6.1",
  id: "jhu_svg__path24",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M317.8 304.6c0-3.5-.1-4-2-4.2l-.8-.1c-.2-.1-.1-.7.1-.8 1.6.1 2.7.1 4.1.1 1.3 0 2.4 0 4.1-.1.2.1.3.7.1.8l-.8.1c-1.9.2-2 .7-2 4.2v11.6c0 3.5.1 3.9 2 4.1l.8.1c.2.1.1.7-.1.8-1.6-.1-2.7-.1-4.1-.1-1.4 0-2.5 0-4.1.1-.2-.1-.3-.6-.1-.8l.8-.1c1.9-.2 2-.7 2-4.1z",
  id: "jhu_svg__path26",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M354.1 316.3c0 3.4.1 3.9 2 4.1l1 .1c.2.1.1.7-.1.8-1.9-.1-3-.1-4.3-.1-1.3 0-2.5 0-4.5.1-.2-.1-.3-.7 0-.8l1.2-.1c1.9-.2 2-.7 2-4.1v-14.6c0-1 0-1-1-1h-1.8c-1.4 0-3.2.1-4 .8-.8.7-1.1 1.4-1.5 2.3-.3.2-.7 0-.8-.2.5-1.5 1-3.6 1.2-4.9.1-.1.5-.1.6 0 .2 1 1.3 1 2.8 1h13.2c1.8 0 2.1-.1 2.5-.9.2-.1.5 0 .6.1-.4 1.3-.6 4-.5 5-.1.3-.7.3-.9.1-.1-.8-.3-2-.8-2.4-.8-.6-2-.8-3.8-.8H355c-1 0-.9 0-.9 1.1z",
  id: "jhu_svg__path28",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M391.3 316.3c0 3.5.2 4 2 4.1l1.3.1c.2.2.1.7-.1.8-2-.1-3.1-.1-4.4-.1-1.4 0-2.5 0-4.3.1-.2-.1-.3-.6-.1-.8l1-.1c1.9-.2 2-.7 2-4.1v-1.7c0-1.8-.1-2.2-1-4l-3.9-7.5c-1.1-2.2-1.6-2.3-2.6-2.5l-.9-.2c-.2-.2-.2-.7.1-.8 1 .1 2.2.1 3.8.1 1.5 0 2.7 0 3.5-.1.3.1.3.6.1.8l-.4.1c-1.1.2-1.4.3-1.4.6s.9 2.2 1 2.5c1.2 2.4 2.4 5 3.7 7.3 1-1.7 2.1-3.6 3.1-5.5.9-1.7 2.1-3.9 2.1-4.3 0-.2-.6-.4-1.4-.5l-.6-.1c-.2-.2-.2-.7.1-.8 1.2.1 2.1.1 3.1.1s1.9 0 3-.1c.3.2.3.6.1.8l-.9.2c-1.7.3-2.7 2.4-4.3 5.2l-2.1 3.6c-1.4 2.5-1.5 2.8-1.5 5.3v1.5z",
  id: "jhu_svg__path30",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-76.1 331.9c2.8-1.5 6.2-3.7 9.8-6.4v-33l-9.8-6.5z",
  id: "jhu_svg__path32",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-76.1 263.1l9.8 6.5v-16.7c-3.3-.2-6.5-.2-9.8-.3z",
  id: "jhu_svg__path34",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-46.7 254.6c-3.3-.4-6.5-.8-9.8-1v22.5l9.8 6.5z",
  id: "jhu_svg__path36",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-56.5 299v18c3.3-3.3 6.6-7.1 9.8-11.4v0z",
  id: "jhu_svg__path38",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-46.7 305.6s0 0 0 0z",
  id: "jhu_svg__path40",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-36.8 256.1v33.1c4.3-8.9 7.7-19.2 9.7-31.3l-.3-.1c-3.2-.6-6.3-1.2-9.4-1.7",
  id: "jhu_svg__path42",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  id: "jhu_svg__polygon44",
  fill: "#000",
  stroke: "#000",
  d: "M-56.5 299v-22.9l-9.8-6.5v22.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-46.7 282.7v22.9c3.5-4.8 6.8-10.2 9.8-16.3v-.1z",
  id: "jhu_svg__path46",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-36.8 289.3s0-.1 0 0z",
  id: "jhu_svg__path48",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-97.7 294c2.9-.8 5.5-2.4 7.4-4.6-1.1-.4-2.3-.8-3.8-1.1-1 2.3-2.4 4.2-3.6 5.7",
  id: "jhu_svg__path50",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-113.3 289.4c2 2.2 4.5 3.8 7.4 4.6-1.2-1.4-2.6-3.3-3.6-5.7-1.4.3-2.7.7-3.8 1.1",
  id: "jhu_svg__path52",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-103.2 265.5c-1.1 1.2-2.3 2.8-3.4 4.9 1 .1 2.2.2 3.4.3z",
  id: "jhu_svg__path54",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-93.1 285.6c1.8.4 3.3.9 4.5 1.4 1.2-1.9 1.9-4.1 2.1-6.5h-5.7c-.1 1.9-.4 3.5-.9 5.1",
  id: "jhu_svg__path56",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-105.9 264.2c-2.9.8-5.5 2.4-7.4 4.6 1.1.4 2.3.8 3.8 1.1 1.1-2.3 2.4-4.2 3.6-5.7",
  id: "jhu_svg__path58",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-90.3 268.8c-1.9-2.2-4.5-3.8-7.4-4.6 1.2 1.4 2.6 3.3 3.6 5.7 1.5-.3 2.8-.7 3.8-1.1",
  id: "jhu_svg__path60",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-92.1 277.7h5.7c-.2-2.4-1-4.5-2.1-6.5-1.2.5-2.7 1-4.5 1.4.4 1.6.7 3.3.9 5.1",
  id: "jhu_svg__path62",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-100.4 292.7c1.1-1.2 2.3-2.8 3.4-4.9-1.1-.1-2.2-.2-3.4-.3z",
  id: "jhu_svg__path64",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-103.2 280.5h-5.4c.1 1.6.4 3.2.9 4.5 1.4-.2 2.9-.4 4.5-.4z",
  id: "jhu_svg__path66",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-100.4 284.6c1.6.1 3.1.2 4.5.4.4-1.4.8-2.9.9-4.5h-5.4z",
  id: "jhu_svg__path68",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-97 270.5c-1-2.1-2.3-3.8-3.4-4.9v5.2c1.2-.1 2.4-.2 3.4-.3",
  id: "jhu_svg__path70",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-95 277.7c-.1-1.6-.4-3.2-.9-4.5-1.4.2-2.9.4-4.5.4v4.1z",
  id: "jhu_svg__path72",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-106.6 287.8c1 2.1 2.3 3.7 3.4 4.9v-5.2c-1.2 0-2.3.1-3.4.3",
  id: "jhu_svg__path74",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-110.5 272.6c-1.8-.4-3.3-.9-4.5-1.4-1.1 1.9-1.9 4.1-2.1 6.5h5.7c.1-1.8.4-3.5.9-5.1",
  id: "jhu_svg__path76",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-103.2 273.6c-1.6-.1-3.1-.2-4.5-.4-.5 1.4-.8 2.9-.9 4.5h5.4z",
  id: "jhu_svg__path78",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-111.4 280.5h-5.7c.2 2.4 1 4.5 2.1 6.5 1.2-.5 2.7-1 4.5-1.4-.4-1.6-.8-3.2-.9-5.1",
  id: "jhu_svg__path80",
  fill: "#000",
  stroke: "#000"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "jhu_svg__g88",
  transform: "translate(-21 -264)",
  fill: "#000",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-129.8 258c7.2 44.6 35.1 66.3 49 74v-79.3c-16.4.2-32.8 1.9-48.7 5.3zm28 2.8c10.1 0 18.3 8.2 18.3 18.3 0 10.1-8.2 18.3-18.3 18.3-10.1 0-18.3-8.2-18.3-18.3.1-10.1 8.3-18.3 18.3-18.3",
  id: "jhu_svg__path84",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-27.5 223.9v0c-16.5-3.5-33.5-5.4-50.9-5.4-17.5 0-34.5 1.9-51 5.4h-.1c-1.2.3-2 1.3-2 2.6v9.2c0 6.1.4 11.8 1 17.2 17.1-3.6 34.6-5.4 52.1-5.4s35 1.8 52 5.4c.7-5.4 1-11.1 1-17.2v-9.2c0-1.3-.9-2.3-2.1-2.6M-39 246.7c-12.8-2.4-27.4-3.2-39.5-3.2v0c-12 0-26.7.7-39.5 3.2-.5.1-.9-.3-.6-.9l8.4-18.5c.1-.2 5.5-2.9 5.5-2.9 6.9-1.4 18.3-.8 26.2 2.1v0c7.9-2.9 19.3-3.6 26.2-2.1 0 0 5.4 2.7 5.5 2.9l8.4 18.5c.3.6-.1 1-.6.9",
  id: "jhu_svg__path86",
  fill: "#000",
  stroke: "#000"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "jhu_svg__g94",
  transform: "translate(-21 -264)",
  fill: "#000",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-54.4 227.6l3.5 9.5c-8.2-1.1-15-.6-25.1 2.7v.9c9.5-.4 21.5-.9 31.3 1.2l-5.3-12.2z",
  id: "jhu_svg__path90",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M-106.1 237.1l3.5-9.5-4.4 2-5.3 12.2c9.7-2.1 21.8-1.6 31.3-1.2v-.9c-10-3.2-16.9-3.7-25.1-2.6",
  id: "jhu_svg__path92",
  fill: "#000",
  stroke: "#000"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "jhu_svg__g98",
  transform: "translate(-21 -264)",
  fill: "#000",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M7.5 241c0-8.3-.7-9.2-5.2-9.6l-1.9-.1c-.5-.3-.3-1.7.2-1.9 4.3.1 6.9.2 10 .2 3 0 5.6-.1 8.6-.2.5.2.6 1.6.2 1.9l-1.1.1c-4.4.6-4.6 1.6-4.6 9.6v27.8c0 5.9-.3 11.1-1.7 14.5-2.5 6-7.8 10.8-14.8 10.8-.9 0-3.2-.1-3.2-1.6 0-1.3 1.1-3.5 2.7-3.5.9 0 1.8.1 2.8.5 1 .3 2.1.5 3.1.5 1.6 0 2.5-.9 3-2 1.7-3.5 1.9-14.8 1.9-18.8z",
  id: "jhu_svg__path96",
  fill: "#000",
  stroke: "#000"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "jhu_svg__g122",
  transform: "translate(-21 -264)",
  fill: "#000",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M19.2 258.7c0-12.6 9.5-22.3 22.5-22.3 14.6 0 22 10.6 22 21.7 0 12.8-9.7 22.1-22 22.1-14-.1-22.5-10.1-22.5-21.5m38.2 1.3c0-10.4-4.6-21.7-16.7-21.7-6.6 0-15.1 4.5-15.1 18.4 0 9.4 4.6 21.5 17 21.5 7.6 0 14.8-5.7 14.8-18.2",
  id: "jhu_svg__path100",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M78.1 258.7c-3 0-3.2.1-3.2 2v8.9c0 6.6.3 7.5 3.9 7.9l1.8.2c.4.2.3 1.4-.1 1.6-3.4-.1-5.6-.2-8-.2-2.7 0-4.9.1-7.3.2-.4-.2-.5-1.2-.1-1.6l1.1-.2c3.5-.6 3.7-1.3 3.7-7.9v-22.8c0-6.6-.4-7.7-3.7-8l-1.6-.1c-.4-.3-.3-1.4.1-1.6 3.1.1 5.3.2 8 .2 2.5 0 4.6-.1 7.3-.2.4.2.5 1.3.1 1.6l-1.2.1c-3.7.4-3.8 1.3-3.8 8v7.3c0 2 .1 2 3.2 2h18.1c3 0 3.2-.1 3.2-2v-7.3c0-6.6-.1-7.6-3.9-8l-1.2-.1c-.4-.3-.3-1.4.1-1.6 2.9.1 5.1.2 7.7.2 2.5 0 4.6-.1 7.5-.2.4.2.5 1.3.1 1.6l-1.3.1c-3.7.4-3.8 1.3-3.8 8v22.8c0 6.6.1 7.5 3.8 7.9l1.5.2c.4.2.3 1.4-.1 1.6-3-.1-5.2-.2-7.7-.2-2.6 0-4.9.1-7.7.2-.4-.2-.5-1.2-.1-1.6l1.2-.2c3.9-.6 3.9-1.3 3.9-7.9v-8.9c0-1.9-.1-2-3.2-2z",
  id: "jhu_svg__path102",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M153.1 268.4c0 1.9 0 9.4.2 11.1-.1.4-.5.7-1.2.7-.8-1.1-2.6-3.3-8.1-9.6l-14.7-16.7c-1.7-2-6-7.2-7.3-8.5h-.1c-.3.8-.3 2.2-.3 4.1v13.8c0 3 .1 11.2 1.1 13.1.4.7 1.6 1.1 3.2 1.2l2 .2c.4.5.3 1.3-.1 1.6-2.8-.1-5.1-.2-7.4-.2-2.7 0-4.4.1-6.6.2-.4-.3-.5-1.2-.1-1.6l1.7-.2c1.5-.2 2.5-.6 2.8-1.3.9-2.3.8-10 .8-13V245c0-1.8-.1-3.1-1.4-4.6-.9-.9-2.4-1.3-3.9-1.5l-1.1-.1c-.4-.4-.4-1.3.1-1.6 2.7.2 6 .2 7.1.2 1 0 2.1-.1 2.9-.2 1.3 3.2 8.7 11.6 10.8 13.9l6.1 6.9c4.4 4.9 7.5 8.4 10.4 11.5h.1c.3-.3.3-1.3.3-2.7v-13.5c0-3-.1-11.2-1.3-13.1-.4-.6-1.4-.9-3.9-1.3l-1.1-.1c-.4-.4-.4-1.4.1-1.6 2.9.1 5.1.2 7.5.2 2.7 0 4.4-.1 6.5-.2.5.3.5 1.2.1 1.6l-.9.1c-2 .3-3.3.8-3.5 1.3-1.1 2.3-.9 10.1-.9 13v15.2z",
  id: "jhu_svg__path104",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M169.8 280.1c-5.3 0-8.7-1.6-9.9-2.3-.8-1.4-1.6-5.9-1.7-8.9.3-.4 1.3-.6 1.5-.2.9 3.2 3.5 9.4 10.9 9.4 5.3 0 7.9-3.5 7.9-7.3 0-2.8-.6-5.9-5.2-8.9l-6-3.9c-3.2-2.1-6.8-5.7-6.8-10.9 0-6 4.7-10.9 12.9-10.9 2 0 4.2.4 5.9.8.8.3 1.7.4 2.2.4.6 1.5 1.1 5.1 1.1 7.7-.2.4-1.3.6-1.6.2-.8-3-2.5-7.2-8.6-7.2-6.2 0-7.5 4.1-7.5 7 0 3.7 3 6.3 5.4 7.8l5.1 3.2c4 2.5 7.9 6.1 7.9 12.2 0 7.1-5.3 11.8-13.5 11.8",
  id: "jhu_svg__path106",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M220.8 254.9c-3.6 0-3.7.1-3.7 2.4v10.6c0 7.9.4 8.9 4.6 9.4l2.2.2c.4.3.3 1.6-.2 1.9-4.1-.1-6.6-.2-9.5-.2-3.2 0-5.8.1-8.7.2-.5-.2-.6-1.4-.1-1.9l1.3-.2c4.2-.8 4.4-1.5 4.4-9.4v-27c0-7.9-.5-9.2-4.4-9.4l-2-.2c-.5-.3-.3-1.7.2-1.9 3.7.1 6.2.2 9.4.2 2.9 0 5.5-.1 8.7-.2.5.2.6 1.6.1 1.9l-1.4.2c-4.3.5-4.5 1.6-4.5 9.4v8.6c0 2.3.2 2.4 3.7 2.4h21.5c3.6 0 3.7-.1 3.7-2.4v-8.6c0-7.9-.1-9-4.6-9.4l-1.4-.2c-.5-.3-.3-1.7.2-1.9 3.4.2 6 .2 9.1.2 2.9 0 5.5-.1 8.8-.2.4.2.6 1.6.1 1.9l-1.6.2c-4.3.5-4.5 1.6-4.5 9.4v27c0 7.9.2 8.8 4.5 9.4l1.8.2c.5.3.3 1.6-.2 1.9-3.6-.1-6.1-.2-9.1-.2-3.1 0-5.8.1-9.1.2-.5-.2-.6-1.4-.2-1.9l1.4-.2c4.6-.8 4.6-1.5 4.6-9.4v-10.6c0-2.2-.1-2.4-3.7-2.4z",
  id: "jhu_svg__path108",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M258 258.7c0-12.6 9.5-22.3 22.5-22.3 14.6 0 22 10.6 22 21.7 0 12.8-9.7 22.1-22 22.1-14-.1-22.5-10.1-22.5-21.5m38.1 1.3c0-10.4-4.6-21.7-16.7-21.7-6.6 0-15.1 4.5-15.1 18.4 0 9.4 4.6 21.5 17 21.5 7.6 0 14.8-5.7 14.8-18.2",
  id: "jhu_svg__path110",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M313.9 269.6c0 6.6.1 7.5 4.2 7.9l1.7.2c.4.3.3 1.4-.1 1.6-3.6-.1-5.7-.2-8.2-.2-2.7 0-4.9.1-7.7.2-.4-.2-.5-1.2-.1-1.6l1.3-.2c3.7-.5 3.8-1.3 3.8-7.9v-23.3c0-5.4-.1-6.5-3-6.8l-2.3-.3c-.4-.4-.4-1.3.1-1.6 3.4-.4 7.3-.5 12.5-.5 5.3 0 9.2.7 12.2 2.5 2.9 1.8 5.1 5.1 5.1 9.5 0 5.8-3.6 8.7-6.3 10.1-2.8 1.3-6.1 1.9-8.7 1.9-.4-.2-.4-1.1-.1-1.3 6.8-1.3 9.3-5.1 9.3-10.6 0-6.1-3.6-10.1-10.2-10.1-3.4 0-3.4.2-3.4 2.3v28.2z",
  id: "jhu_svg__path112",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M340.3 246.9c0-6.6-.1-7.7-3.8-8l-1.6-.1c-.4-.3-.2-1.4.1-1.6 3.1.1 5.1.2 8 .2 2.5 0 4.6-.1 7.3-.2.4.2.5 1.3.1 1.6l-1.2.1c-3.7.4-3.8 1.3-3.8 8v7.3c0 1.2.1 2.4.8 2.4.6 0 1.3-.4 1.8-.7.9-.8 2.5-2.4 3.2-3l6.8-6.8c1.2-1.1 4.3-4.4 4.9-5.3.3-.4.4-.8.4-1 0-.2-.3-.4-1.1-.6l-1.7-.4c-.4-.4-.4-1.3.1-1.6 2.2.1 4.7.2 7 .2 2.2 0 4.4-.1 6.3-.2.4.3.5 1.2.1 1.6-1.6.1-4.1.8-5.9 1.8-1.8 1-5.3 4-8.9 7.3l-5.7 5.4c-.9.9-1.5 1.5-1.5 2 0 .4.4 1 1.2 2 6 6.9 10.9 12.6 15.8 17.8 1.5 1.5 2.7 2.3 4.8 2.6l1.2.2c.4.3.3 1.4-.1 1.6-1.6-.1-3.4-.2-6.4-.2-2.6 0-4.8.1-7.7.2-.4-.1-.6-1.2-.2-1.6l1.5-.3c.9-.1 1.5-.3 1.5-.6 0-.4-.4-.9-.9-1.5-1.2-1.5-2.8-3.2-5.2-5.9l-5.1-5.7c-3.6-4-4.6-5.3-6.1-5.3-1 0-1.1.8-1.1 3v8.2c0 6.6.1 7.5 3.7 7.9l1.7.2c.4.3.3 1.4-.1 1.6-3.1-.1-5.3-.2-7.7-.2-2.6 0-4.7.1-7.3.2-.4-.2-.5-1.1-.1-1.6l1.3-.2c3.4-.5 3.5-1.3 3.5-7.9v-22.9z",
  id: "jhu_svg__path114",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M383.7 247c0-6.7-.1-7.8-3.9-8.1l-1.6-.1c-.4-.3-.3-1.4.1-1.6 3.2.1 5.3.2 8 .2 2.5 0 4.7-.1 7.8-.2.4.2.5 1.3.1 1.6l-1.6.1c-3.7.3-3.9 1.4-3.9 8.1v22.5c0 6.7.1 7.6 3.9 8l1.6.2c.4.3.3 1.4-.1 1.6-3.2-.1-5.3-.2-7.8-.2-2.7 0-4.6.1-7.7.2-.4-.2-.5-1.2-.1-1.6l1.3-.2c3.7-.4 3.9-1.3 3.9-8z",
  id: "jhu_svg__path116",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M438.4 268.4c0 1.9 0 9.4.2 11.1-.1.4-.5.7-1.2.7-.8-1.1-2.6-3.3-8.1-9.6l-14.7-16.7c-1.7-2-6-7.2-7.3-8.5h-.1c-.3.8-.3 2.2-.3 4.1v13.8c0 3 .1 11.2 1.1 13.1.4.7 1.6 1.1 3.2 1.2l2 .2c.4.5.3 1.3-.1 1.6-2.8-.1-5.1-.2-7.4-.2-2.7 0-4.4.1-6.6.2-.4-.3-.5-1.2-.1-1.6l1.7-.2c1.5-.2 2.5-.6 2.8-1.3.9-2.3.8-10 .8-13V245c0-1.8-.1-3.1-1.4-4.6-.9-.9-2.4-1.3-3.9-1.5l-1.1-.1c-.4-.4-.4-1.3.1-1.6 2.7.2 6 .2 7.1.2 1 0 2.1-.1 2.9-.2 1.3 3.2 8.7 11.6 10.8 13.9l6.1 6.9c4.4 4.9 7.5 8.4 10.4 11.5h.1c.3-.3.3-1.3.3-2.7v-13.5c0-3-.1-11.2-1.3-13.1-.4-.6-1.4-.9-3.9-1.3l-1.1-.1c-.4-.4-.4-1.4.1-1.6 2.9.1 5.1.2 7.5.2 2.7 0 4.4-.1 6.5-.2.5.3.5 1.2.1 1.6l-.9.1c-2 .3-3.3.8-3.5 1.3-1.1 2.3-.9 10.1-.9 13v15.2z",
  id: "jhu_svg__path118",
  fill: "#000",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "jhu_svg__st0",
  d: "M455 280.1c-5.3 0-8.7-1.6-9.9-2.3-.8-1.4-1.6-5.9-1.7-8.9.3-.4 1.3-.6 1.5-.2 1 3.2 3.5 9.4 10.9 9.4 5.3 0 7.9-3.5 7.9-7.3 0-2.8-.6-5.9-5.2-8.9l-6-3.9c-3.2-2.1-6.8-5.7-6.8-10.9 0-6 4.7-10.9 12.9-10.9 2 0 4.2.4 5.9.8.8.3 1.7.4 2.2.4.6 1.5 1.1 5.1 1.1 7.7-.3.4-1.3.6-1.6.2-.8-3-2.5-7.2-8.6-7.2-6.2 0-7.5 4.1-7.5 7 0 3.7 3 6.3 5.4 7.8l5.1 3.2c4 2.5 7.9 6.1 7.9 12.2 0 7.1-5.2 11.8-13.5 11.8",
  id: "jhu_svg__path120",
  fill: "#000",
  stroke: "#000"
}));

function SvgJhu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "jhu_svg__layer",
    x: 0,
    y: 0,
    viewBox: "-153 -46 601 114.849",
    xmlSpace: "preserve",
    width: 601,
    height: 114.849
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "static/jhu.387af258.svg";
export { SvgJhu as ReactComponent };